import React, {Component} from 'react';
import {
  withRouter, Link
} from 'react-router-dom';
import {connect} from 'react-redux';

// CSS
import styleFooter from '../../Styles/Components/Footer.module.css';

class Footer extends Component {
  constructor() {
    super();
  }


  render() {
    return (
      <div className={styleFooter.footerContainer} style={this.props.customStyle}>
        <div onClick={this.props.onClick && this.props.onClick.bind(this)}>{this.props.content}</div>
      </div>
    );
  }
}

export default connect()(withRouter(Footer));

